import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore, enableIndexedDbPersistence } from "firebase/firestore";

const stagingConfig = {
  apiKey: "AIzaSyDKRPc_vaWW0IrGX7Nrjexz_I8bqIMaNnA",
  authDomain: "the-promise-muscle-app.firebaseapp.com",
  projectId: "the-promise-muscle-app",
  storageBucket: "the-promise-muscle-app.firebasestorage.app",
  messagingSenderId: "301070376939",
  appId: "1:301070376939:web:333ddcb10194d991dec3ae",
  measurementId: "G-C0YNKQKTX2",
};

const productionConfig = {
  apiKey: "AIzaSyCvT6KfCKFzpATF6rnfwcbTMAy5mvuxW9g",
  authDomain: "the-project-muscle---prod.firebaseapp.com",
  projectId: "the-project-muscle---prod",
  storageBucket: "the-project-muscle---prod.firebasestorage.app",
  messagingSenderId: "272369379128",
  appId: "1:272369379128:web:b9ed6e1620e057f28f43cd",
  measurementId: "G-Z87Y8TE0GE",
};

const firebaseConfig =
  process.env.REACT_APP_ENV === "production" ? productionConfig : stagingConfig;

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);

enableIndexedDbPersistence(db).catch((err) => {
  console.log("Offline persistence error:", err.code);
});
